var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginGirl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800.314,
    height: 644.708,
    viewBox: "0 0 800.314 644.708",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-376.703 -155.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(376.703 394.331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M602.879,191.732a41.761,41.761,0,0,0,0,83.522H914.1a41.761,41.761,0,1,0,0-83.522Z",
    transform: "translate(-561.118 -191.732)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.443,202.747a33.309,33.309,0,1,0,0,66.619H916.662a33.309,33.309,0,0,0,0-66.619Z",
    transform: "translate(-563.682 -194.296)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.91,271.217H623.989a1.492,1.492,0,1,1,0-2.983H685.91a1.492,1.492,0,0,1,0,2.983Z",
    transform: "translate(-575.405 -209.539)",
    fill: "#efb735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.292,271.865H726.371a1.491,1.491,0,0,1,0-2.983h61.921a1.491,1.491,0,0,1,0,2.983Z",
    transform: "translate(-599.236 -209.69)",
    fill: "#efb735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.674,272.513H828.753a1.492,1.492,0,0,1,0-2.983h61.921a1.491,1.491,0,1,1,0,2.983Z",
    transform: "translate(-623.067 -209.84)",
    fill: "#efb735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.055,273.161H931.134a1.491,1.491,0,0,1,0-2.983h61.921a1.492,1.492,0,0,1,0,2.983Z",
    transform: "translate(-646.898 -209.991)",
    fill: "#efb735"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.509,
    cy: 11.509,
    r: 11.509,
    transform: "translate(67.9 24.934)",
    fill: "#efb735"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.509,
    cy: 11.509,
    r: 11.509,
    transform: "translate(146.926 24.934)",
    fill: "#efb735"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.509,
    cy: 11.509,
    r: 11.509,
    transform: "translate(225.951 24.934)",
    fill: "#efb735"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.509,
    cy: 11.509,
    r: 11.509,
    transform: "translate(304.976 24.934)",
    fill: "#efb735"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(650.718 262.182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.108,645.409a10.02,10.02,0,0,1-3.437-.608l-74.652-27.132a10.075,10.075,0,0,1,1.506-19.357L500.7,557.949a10.1,10.1,0,0,1,5.011.292L563.317,576.7a10.077,10.077,0,0,1-.546,19.351L373.64,645.087a10.05,10.05,0,0,1-2.532.323Z",
    transform: "translate(-286.383 -150.45)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.22,518.082l108.275,13.012-19.74,38.069-95.461-13.856c-7.86,5.575-18.784,8.056-30.142,5.944-19.871-3.7-33.5-20.025-30.439-36.474S446.364,498,466.235,501.7C477.592,503.807,486.891,510.054,492.22,518.082Z",
    transform: "translate(-256.506 -118.027)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.371,105.763a86.173,86.173,0,1,0-86.654,108.605l44.807,101.938,63.516-90.48s-23.808-17.772-40.181-40.642a86.079,86.079,0,0,0,18.512-79.421Z",
    transform: "translate(-271.314 -11.219)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.908,342.528a76.523,76.523,0,0,0-70.29-47.753c-39.017-.376-88.681,9.827-90.728,63.75-3.39,89.283,0,53.346,0,53.346s-26.935,67.068,0,99.417S659.311,607.4,659.311,607.4H822.986s-28.256-74.676-23.4-125.623c3.294-34.583-12.416-96.553-29.677-139.245Z",
    transform: "translate(-296.688 -70.035)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.162,261.161c-4.484,8.084-17.433,7.626-23.823.945s-7.457-16.867-6.454-26.056,3.71-18.226,3.524-27.467c-.356-17.636,22.646,11.185,10.831-1.912s-25.325-25.128-33.4-40.811l-.975-1c3.449-11.392-4.916-23.029-14.332-30.306S744.828,121.719,738.4,111.7c-5.47-8.521-6.575-19-8.969-28.843-9.275-38.121-41.338-69.742-79.583-78.488s-80.866,5.8-105.787,36.1l.6-1.256a45.1,45.1,0,0,0-34,32.428c-1.169,4.639-1.558,9.627,0,14.152s5.348,8.476,10.074,9.225c5.068.8,10.139-2.178,13.262-6.251s4.68-9.1,6.179-14.005a60.626,60.626,0,0,0,44.177,42.3,15.805,15.805,0,0,0,22.527,16.275l1.2-1.144,17.7.8A59.313,59.313,0,0,0,640.95,217.6c10.688,7.046,23.311,10.434,35.714,13.6s16.066,25.373,32.379,44.66c-.864,21.916,15.4,43.3,36.756,48.311l-5.862,19.676c11.877-4.224,24.88-.377,37.42.9s27.745-1.765,32.564-13.412c5.124-12.385-4.659-25.516-13.76-35.355,18.528,1.848,36.29-16.342,34.006-34.819Z",
    transform: "translate(-310.117 -1.856)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.587,595.936l105.437,27.851-24.812,34.974-92.63-26.92c-8.555,4.435-19.718,5.384-30.674,1.721-19.17-6.409-30.41-24.466-25.106-40.331s25.145-23.527,44.318-17.118c10.956,3.663,19.3,11.136,23.47,19.824Z",
    transform: "translate(-244.682 -134.996)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.82,439.676s-4.6,202.27-70.563,195.525-87.792-15.237-87.792-15.237-13.344-50.944,9.7-52.16,53.125-6.887,53.125-6.887v-146.7",
    transform: "translate(-280.094 -97.839)",
    fill: "#d6d6e3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M287.66,221.286c-4.3,1.8-8.8-.172-10.68-4.684-1.913-4.58-.126-9.23,4.247-11.056s8.786.148,10.729,4.8C293.871,214.933,292.1,219.43,287.66,221.286Zm-8.246-24.756-3.423,1.429a3.692,3.692,0,0,1-4.69-1.72l-.169-.331c-3.683-6.642-4.1-14.714-1.247-23.98,2.647-8.312,3.747-14.158,1.536-19.454-2.557-6.123-8.016-8.041-14.979-5.263-2.7,1.128-3.56,1.11-5.685,3.218a4.879,4.879,0,0,1-3.532,1.435,4.716,4.716,0,0,1-3.375-1.48,4.817,4.817,0,0,1-.033-6.573,37.414,37.414,0,0,1,12.652-8.687c14.959-6.246,22.489,2.976,25.935,11.228,3.371,8.072,1.475,15.562-1.572,25.261-2.553,8.06-2.4,14.032.5,19.97a3.676,3.676,0,0,1-1.915,4.946Z",
    transform: "translate(579.249 21.932)",
    fill: "#efb735"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginGirl);
export default __webpack_public_path__ + "static/media/login-girl.70d20f80c4f1956acd68e00410afddf3.svg";
export { ForwardRef as ReactComponent };